import React from 'react';

import styles from './Detail.module.scss';
import Modal from './Modal';
import Icon from './Icon';
import SlidingPanel from './SlidingPanel';
import { useDeviceDetection } from '../utils/DeviceDetection';
import { capitalize } from '../api/geocmsUtil';
import FloatingToggleButton from './FloatingToggleButton';

export default function Detail({ result, onClose }) {
	const isMobile = useDeviceDetection();

	const [detailFilterValue, setDetailFilterValue] = React.useState('');

	let filteredDetail = result.detail;

	if (detailFilterValue) {
		filteredDetail = filteredDetail.filter((det) => {
			return (
				det['SPECIALITA'].toLowerCase().includes(detailFilterValue) ||
				det['MEDICO'].toLowerCase().includes(detailFilterValue)
			);
		});
	}

	filteredDetail.sort((a, b) => {
		let compare = null;
		a['SPECIALITA'] < b['SPECIALITA']
			? (compare = -1)
			: a['SPECIALITA'] > b['SPECIALITA']
			? (compare = 1)
			: (compare = 0);

		return compare;
	});

	const detailContent = (
		<>
			<h3>{result.name}</h3>
			<p className={styles.subtitle}>{capitalize(result.address)}</p>
			<div className={styles.separator}></div>
			<div className={styles.controls}>
				<strong>I Medici della struttura </strong>
				<div className={styles.inputContainer}>
					<input
						type="text"
						placeholder="Cerca per nome o specializzazione..."
						className={styles.detailFilter}
						value={detailFilterValue}
						onChange={(event) =>
							setDetailFilterValue(event.target.value)
						}
					></input>

					<FloatingToggleButton
						icon={<Icon icon="icon/close_grey.png" size="small" />}
						right="0px"
						top="8px"
						className={styles.clearButton}
						onClick={() => setDetailFilterValue('')}
					/>
				</div>
			</div>
			<div className={styles.tableContainer}>
				{buildTable(
					filteredDetail,
					['SPECIALITA', 'MEDICO'],
					['Spacializzazione', 'Nome']
				)}
			</div>
		</>
	);

	return !isMobile ? (
		<Modal
			show={true}
			onClose={onClose}
			modalClassName={styles.detailModal}
		>
			{detailContent}
		</Modal>
	) : (
		<SlidingPanel
			show={true}
			variant="secondary"
			onClose={onClose}
			className={styles.detailPanel}
		>
			{detailContent}
		</SlidingPanel>
	);
}

function buildTable(objects, propNames, columNames) {
	if (
		!(
			objects &&
			propNames &&
			columNames &&
			propNames.length == columNames.length
		)
	)
		return;

	return (
		<table>
			<thead>
				<tr>
					{columNames.map((columnName) => (
						<th>{columnName}</th>
					))}
				</tr>
			</thead>
			<tbody>
				{objects.map((obj) => (
					<tr>
						{propNames.map((propName) => (
							<td>{capitalize(obj[propName])}</td>
						))}
					</tr>
				))}
			</tbody>
		</table>
	);
}
